module.exports = __webpack_public_path__ + "static/media/Propx-Logo-Black.008b31dc.svg";